import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import {
  VISIT_STATUS_NEW,
  VISIT_STATUS_STARTED,
  VISIT_STATUS_COMPLETED,
} from "@/schemas/contractorVisit";

interface StatusFilterProps {
  value?: string;
  onChange: (value: string | undefined) => void;
}

export const StatusFilter = ({ value, onChange }: StatusFilterProps) => {
  const { t } = useTranslation();

  const statusOptions = [
    {
      value: VISIT_STATUS_NEW,
      label: t("contractorVisitsStatuses.new"),
      color: "bg-yellow-500",
    },
    {
      value: VISIT_STATUS_STARTED,
      label: t("contractorVisitsStatuses.started"),
      color: "bg-blue-500",
    },
    {
      value: VISIT_STATUS_COMPLETED,
      label: t("contractorVisitsStatuses.completed"),
      color: "bg-green-500",
    },
  ];

  const selectedOption = statusOptions.find((opt) => opt.value === value);

  return (
    <div className="space-y-2">
      <Label htmlFor="status-filter">
        {t("contractorVisits.filter.status.label")}
      </Label>
      <Select
        value={value || "all"}
        onValueChange={(newValue) =>
          onChange(newValue === "all" ? undefined : newValue)
        }
      >
        <SelectTrigger>
          {value && selectedOption ? (
            <div className="flex items-center gap-2">
              <div
                className={cn("w-2 h-2 rounded-full", selectedOption.color)}
              />
              <span>{selectedOption.label}</span>
            </div>
          ) : (
            <SelectValue
              placeholder={t("contractorVisits.filter.status.placeholder")}
            />
          )}
        </SelectTrigger>
        <SelectContent className="z-[60]">
          <SelectItem value="all">
            {t("contractorVisits.filter.status.all")}
          </SelectItem>
          {statusOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center gap-2">
                <div className={cn("w-2 h-2 rounded-full", option.color)} />
                <span>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
